// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + __webpack_require__.h() + "." + chunkId + ".1782997315743.css";
};